import { motion } from 'framer-motion';
import { UserDancer } from './NameModal';
import { BRAND } from '../constants/brand';

export const HeroSection = ({ userDancer }) => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center justify-center bg-aya-black overflow-hidden"
      data-testid="hero-section"
    >
      {/* User's personalized dancers - scattered, hidden on mobile */}
      {userDancer && (
        <>
          <UserDancer position="pos-1" delay={200} />
          <UserDancer position="pos-2" delay={400} />
          <UserDancer position="pos-3" delay={600} />
          <UserDancer position="pos-4" delay={800} />
        </>
      )}

      <div className="container relative mx-auto px-4 md:px-8 py-24 md:py-28">
        <motion.div 
          className="max-w-5xl mx-auto text-left"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div variants={itemVariants} className="max-w-4xl">
            <h1 
              className="font-heading text-5xl font-black tracking-[-0.035em] text-white sm:text-6xl md:text-7xl lg:text-[6.5rem] lg:leading-[0.94]"
              data-testid="hero-title"
            >
              <span className="block text-white">the</span>
              <span className="block text-aya-yellow">Dance</span>
              <span className="block text-aya-yellow">Ecosystem,</span>
              <span className="block text-white">organized.</span>
            </h1>
          </motion.div>

          <motion.div 
            variants={itemVariants}
            className="mt-8 max-w-2xl"
          >
            <p className="text-lg leading-relaxed text-zinc-300 md:text-3xl md:leading-relaxed">
              A platform built to connect{' '}
              <span className="italic highlight-word text-white">artists</span>,{' '}
              <span className="italic highlight-word text-white">studios</span> &{' '}
              <span className="italic highlight-word text-white">anyone who loves dancing</span>.
            </p>
          </motion.div>

          <motion.p 
            variants={itemVariants}
            className="mt-10 max-w-xl text-sm font-medium uppercase tracking-[0.24em] text-zinc-500 md:text-base"
            data-testid="hero-subtext"
          >
            {BRAND.tagline}
          </motion.p>

          <motion.div 
            variants={itemVariants}
            className="mt-10 flex flex-col items-start gap-4 sm:flex-row"
          >
            <button
              onClick={() => scrollToSection('#waitlist')}
              className="
                hero-outline-btn rounded border border-aya-yellow bg-transparent
                px-5 py-3 text-sm font-heading font-bold text-aya-yellow
                sm:px-7 sm:py-3.5 sm:text-base
              "
              data-testid="hero-cta-waitlist"
            >
              Join the Waitlist
            </button>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <div className="w-6 h-10 border-2 border-white/20 rounded-full flex justify-center pt-2">
          <motion.div 
            animate={{ y: [0, 8, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="w-1 h-2 bg-white/40 rounded-full"
          />
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
